import { useEffect, useState } from 'react';
import { ButtonHeadless, Modal, TextInput } from '@wajeez-web/components/ui';
import { useDebounce } from '@wajeez-web/components/helpers';
import {
  CollectionComponetsActions,
  ComponentsActions,
  useContentDispatch,
  useContentSelector,
} from '@wajeez-web/stores/content';
import { Server } from '@wajeez/wajeez.microservices';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';

interface FlowComponentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (
    selectedCollectionComponent:
      | Server.CollectionComponentLookUpOutput
      | undefined
  ) => void;
}

export const FlowComponentsModal = ({
  isOpen,
  onClose,
  onSubmit,
}: FlowComponentsModalProps) => {
  const contentDispatch = useContentDispatch();

  const [selectedComponent, setSelectedComponent] =
    useState<Server.CollectionComponentLookUpOutput>();

  const components = useContentSelector(
    ({ components }) => components.componentLookups
  );

  const [setSearchTermDebounced] = useDebounce((data) => {
    contentDispatch(
      ComponentsActions.getComponentLookupsAsync({
        searchText: data?.value,
      })
    );
  });

  useEffect(() => {
    contentDispatch(ComponentsActions.getComponentLookupsAsync({}));
  }, []);

  const renderComponents = () => {
    return components.data.map((c) => {
      return (
        <div
          key={c.id}
          className={`w-full py-4 px-3 rounded-md border break-all text-center flex justify-center items-center cursor-pointer ${
            selectedComponent?.id === c.id && 'border-primary'
          }`}
          onClick={() => {
            setSelectedComponent(c);
          }}
        >
          {c.referenceName}
        </div>
      );
    });
  };

  return (
    <Modal title="Choose Component" open={isOpen} onClose={onClose}>
      <div className="w-full h-full">
        <div className="w-full max-w-[300px] px-2">
          <TextInput
            name="component-search"
            label="Search"
            onChange={(name, value) => {
              setSearchTermDebounced({ value });
            }}
          />
        </div>
        <div className="mt-5 px-2 w-full h-[380px] grid grid-cols-3 gap-x-4 gap-y-4 overflow-y-auto">
          {renderComponents()}
        </div>
        <div className="mt-6 w-full flex justify-end items-center">
          <div className="w-[70px]">
            <ButtonHeadless
              paddingYStyle="py-2"
              isDisabled={!selectedComponent}
              bgStyle={!selectedComponent ? 'bg-warmGray-300' : 'bg-primary'}
              action={() => {
                onSubmit(selectedComponent);
              }}
            >
              <div className="text-white">
                <ReturnTranslatedText
                  origintext="Choose"
                  text={`buttons.${'Choose'}`}
                />
              </div>
            </ButtonHeadless>
          </div>
        </div>
      </div>
    </Modal>
  );
};
